/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Immutable from 'immutable';
import {FormattedDate} from 'react-intl';

const CommentList = (props) => {

    const {comments} = props;

    if (!comments || comments.count() === 0) {
        return (
            <div>No Memos Yet.</div>
        );
    }

    const getGroupKey = (item) => {
        if (!item || !item.get) {
            console.warn('CommentList getGroupKey: received unexpected item');
            return '';
        }
        const user = (item.get('userId') || '').trim();
        const enterDate = item.get('commentEnterDate');
        const date = enterDate ? moment(new Date(enterDate)).startOf('day') : '';
        const seq = item.get('commentTransactionSeq') || '';
        return `${date}_${seq}_${user}`;
    };

    const groupList = comments.groupBy(item => getGroupKey(item));

    const results = groupList.map((groupItems) => {

        let comment = '';
        groupItems.forEach((groupItem) => {
            const commentLine = groupItem.get('commentLine');
            if (commentLine) {
                comment += commentLine
                    .replace(/ +(?= )/g, '')
                    .toLowerCase()
                    .replace(/([!?.]\s+)([a-z])/g, (m, $1, $2) => {
                        return $1 + $2.toUpperCase();
                    });
            }
        });

        const commentLine = new Immutable
            .Map()
            .set('commentEnterDate', new Date(groupItems.first().get('commentEnterDate')))
            .set('userId', groupItems.first().get('userId') || '')
            .set('commentLine', comment);

        return commentLine;

    });

    const rows = results
        .toList()
        .map((item, index) => {
            return (
                <li key={'comment_' + index}>
                    <div className="wow-fst-comment-list-item-header">
                        <div className="left">
                            <FormattedDate value={item.get('commentEnterDate')}/>
                        </div>

                        <div className="right">
                            {item.get('userId')}
                        </div>
                    </div>

                    <br/> <div className="force-wrap">{item.get('commentLine')}</div>
                </li>
            );
        });

    return (
        <div>

            <ul className="wow-fst-comment-list">
                {rows}
            </ul>

        </div>
    );
};

CommentList.propTypes = {
    comments: PropTypes.object
};
export default CommentList;



// WEBPACK FOOTER //
// ./src/components/comment/CommentList.js